import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const setRobots = (content) => {
  let el = document.querySelector('meta[name="robots"]');
  if (!el) { el = document.createElement('meta'); el.setAttribute('name', 'robots'); document.head.appendChild(el); }
  el.setAttribute('content', content);
};

export const NotFound = ({ label = 'Page Not Found', backTo = '/', backLabel = 'Back to Home' }) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${label} | TelegramEmailBot`;
    setRobots('noindex, follow');
    return () => {
      document.title = prevTitle;
      setRobots('index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1');
    };
  }, [label]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center" style={{ fontFamily: "'Manrope', sans-serif" }} data-testid="not-found-page">
      <div className="text-center px-4">
        <p className="font-outfit font-black text-6xl text-gray-200 mb-2">404</p>
        <h1 className="font-outfit font-bold text-2xl text-gray-900 mb-4">{label}</h1>
        <Link to={backTo} className="text-[#0088CC] font-semibold hover:underline" data-testid="not-found-back-link">{backLabel}</Link>
      </div>
    </div>
  );
};

export default NotFound;
